export default "__VITE_ASSET__DnaGI76a__"